import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

export const GuestGuard = () => {
  const { user, isAuthenticated } = useAuthStore();

  if (isAuthenticated && user) {
    const role = user.role;
    const dashboardMap: Record<string, string> = {
      customer: '/home',
      farmer: '/farmer',
      delivery_agent: '/delivery',
      supplier: '/supplier',
      admin: '/admin',
    };

    return <Navigate to={dashboardMap[role] || '/home'} replace />;
  }

  return <Outlet />;
};
